








































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';

import { agencyStore } from '@/store/store';
import { states } from '@/lib/data/states';
import { UnitSystem } from '@/interfaces/units';
import AgencyCostActivityEditor from '@/modules/agencyCost/views/components/AgencyCostActivityEditor.vue';
import { createNewAgencyCostActivityImperial } from '@/modules/agencyCost/lib/createNew';
import { createAgencyCostValidators } from '@/modules/agencyCost/lib/validations';
import { IAgencyCostActivityImperial } from '@/modules/agencyCost/interfaces/agencyCost';
import AgencyCostPlot from '@/modules/agencyCost/views/components/AgencyCostPlot.vue';

Component.registerHooks(['validations']);

@Component({
  components: {
    AgencyCostActivityEditor,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
    AgencyCostPlot,
  },
})
export default class AgencyCostResults extends Vue {
  @Prop() readonly id!: string;

  @Prop() readonly page!: number;

  showDetails: boolean = true;

  labelColsSm = 6;

  labelColsMd = 6;

  labelColsLg = 6;

  textColsSm = 6;

  textColsMd = 6;

  textColsLg = 6;

  get mainlineArea() {
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return this.scenario.laneWidth_ft * this.scenario.totalLength_mi * 5280; // ft^2
    }
    return this.scenario.laneWidth_m * this.scenario.totalLength_km * 1000; // ft^2
  }

  get insideShoulderArea() {
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return this.scenario.insideShoulderWidth_ft * this.scenario.totalLength_mi * 5280; // ft^2
    }
    return this.scenario.insideShoulderWidth_m * this.scenario.totalLength_km * 1000; // ft^2
  }

  get outsideShoulderArea() {
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      return this.scenario.outsideShoulderWidth_ft * this.scenario.totalLength_mi * 5280; // ft^2
    }
    return this.scenario.outsideShoulderWidth_m * this.scenario.totalLength_km * 1000; // ft^2
  }

  addActivity() {
    this.scenarioImperial.activities.push(createNewAgencyCostActivityImperial(this.scenarioImperial));
  }


  get scenario() {
    return agencyStore.currentScenario;
  }

  get scenarioImperial() {
    return agencyStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  sync() {
    console.log('sync');

    agencyStore.setCurrentScenario(this.scenario);

    this.scenarioImperial.activities.sort((a: IAgencyCostActivityImperial, b: IAgencyCostActivityImperial) => a.yearsAfterStart - b.yearsAfterStart);
  }

  save() {
    this.sync();
    agencyStore.saveCurrentScenario();
  }

  validations() {
    return createAgencyCostValidators(this.scenarioImperial);
  }

  stateOptions = states;
}

